class SectionPromoBar extends HTMLElement {
  constructor() {
    super();
    this.promoBar = document.querySelector("[data-js-promo-bar]");

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.initFunction();
    });
  }

  initFunction() {
    if (!this.promoBar) return;

    const { Swiper, Autoplay, EffectFade } = this.swiperLib;

    const swiperParams = {
      modules: [Autoplay, EffectFade],
      slidesPerView: 1,
      speed: 1000,
      effect: "fade",
      fadeEffect: { crossFade: true },
      loop: true,
      autoplay: { delay: 5000, disableOnInteraction: false },
    };

    const swiper = new Swiper(this.promoBar, swiperParams);
  }
}

if (!customElements.get("section-promo-bar")) {
  customElements.define("section-promo-bar", SectionPromoBar);
}
